/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { WindowResizeService } from '../../../core/services';
import { getShouldOffsetForSidePanel, getShowReplay } from '../../../core/store/selectors';
import { IAppState } from '../../../core/store/state';
import { ManagePostedSpeedAnimationService } from '../../../manage-posted-speed/services/manage-posted-speed-animation.service';
import { MapAnimations } from '../../animations';

@Component({
  selector: 'fm-map-container',
  templateUrl: './map-container.component.html',
  styleUrls: ['./map-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [MapAnimations.overlaySidePanelOpen]
})
export class MapContainerComponent implements OnInit {
  isReplayOpen$: Observable<boolean>;
  // Synced with the panel slide-in timing so the map resize animates together with the panel
  isManagePostedSpeedOpen$: Observable<boolean> = toObservable(this._mpsAnimationService.isPanelSlideIn);
  isMobileOrTablet$: Observable<boolean>;
  shouldOffsetForSidePanel$: Observable<boolean>;

  ngOnInit(): void {
    this.isReplayOpen$ = this._store.pipe(select(getShowReplay));
    this.isMobileOrTablet$ = this._windowResizeService.isMobileOrTablet$;
    this.shouldOffsetForSidePanel$ = this._store.pipe(select(getShouldOffsetForSidePanel));
  }

  constructor(
    private readonly _store: Store<IAppState>,
    private readonly _windowResizeService: WindowResizeService,
    private readonly _mpsAnimationService: ManagePostedSpeedAnimationService
  ) {}
}
